/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Triple_H1Inputs */

const en_map_triple_h1 = /** @type {(inputs: Map_Triple_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triple H`)
};

const fr_map_triple_h1 = /** @type {(inputs: Map_Triple_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triple H`)
};

const ms_sg2_map_triple_h1 = /** @type {(inputs: Map_Triple_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triple H`)
};

/**
* | output |
* | --- |
* | "Triple H" |
*
* @param {Map_Triple_H1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
const map_triple_h1 = /** @type {((inputs?: Map_Triple_H1Inputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Triple_H1Inputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_triple_h1(inputs)
	if (locale === "fr") return fr_map_triple_h1(inputs)
	return ms_sg2_map_triple_h1(inputs)
});
export { map_triple_h1 as "map_triple_H" }